import { getProfileImageTigrisUrl } from '#app/utils/get-profile-image.ts';
import { type IUserImage } from './user-image._._definitions'
import {
	type IUserStatus,
	type IUserType,
	type IUser,
} from './user._._definitions'

export const usersAdminLinkTo = `/admin/users`

export const userAdminLinkTo = (
	userId: IUser['id'],
	typeOrRole: 'users' | 'admins' | 'ai',
) => {
	return `${usersAdminLinkTo}/${typeOrRole}/${userId}`
}

export const mapUsersFields = (users: IUser[]): IUser[] => {
	return users.map(mapUserFields)
}

export const mapUserFields = (user: IUser): IUser => ({
	...user,
	...(user.type && { type: user.type as IUserType }),
	...(user.status && { status: user.status as IUserStatus }),
	...(user.image && { image: {
		...user.image as IUserImage,
		...(user.image.id && { tigrisUrl: getProfileImageTigrisUrl(user.image.path) })
	} }),
})

export const defaultUserAiEmail = (): string => {
	return `info+${new Date().getTime()}@${process.env.APP_DOMAIN}`
}

export const fullName = (user: Pick<IUser, 'name' | 'lastName'>): string => {
	if (!user.name) return 'No name'
	if (!user.lastName) return user.name
	return `${user.name} ${user.lastName ?? ''}`.trim()
}

/** "Scott M" — how staff name people to members. */
export const shortName = (user: Pick<IUser, 'name' | 'lastName'>): string =>
	user.lastName?.trim()
		? `${user.name} ${user.lastName.trim().charAt(0).toUpperCase()}`
		: user.name
